(function (w) {
	var Accordion = function Accordion(context) {
		this.context = context;
		this.items = [];
	};

	Accordion.prototype.init = function init() {
		var self = this;
		// Grab the accordion items from the page
		var tab = this.context.querySelectorAll('.accordion .tab');
		var link = this.context.querySelectorAll('.accordion .tab > a');

		for ( var i = 0; i < tab.length; i++ ) {
			this.items.push( tab[i] );
		}
		// Assign onclick events to the accordion item headings
		for ( var i = 0; i < link.length; i++ ) {
			link[i].addEventListener('click', function (e){
				self.toggleItem(e);
			});
		}
	};

	Accordion.prototype.toggleItem = function toggleItem(e) {
		e.preventDefault();
		var div = e.target.parentNode;
		var isOpened = div.classList.contains('is-opened');
		// Hide all items
		for ( var i = 0; i < this.items.length; i++ ) {
			this.items[i].classList.remove('is-opened');
		}
		// Show this item if it was previously hidden
		if ( !isOpened ) div.classList.add('is-opened');
	};

	var accordion = new Accordion(w.document);
	accordion.init();
	// console.log(accordion.items);

})(window);